import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Styles/LeaveRequest.css";
import Loader from "../../Components/Loader";

function FacultyLeaveHistory() {
    const [allLeaves, setAllLeaves] = useState([]);
    const [filteredLeaves, setFilteredLeaves] = useState([]);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [leavesPerPage] = useState(5);
    const calculateTotalDays = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const timeDifference = end - start;
        const daysDifference = timeDifference / (1000 * 3600 * 24);
        return daysDifference;
    };
    const fetchAllLeaves = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("No authentication token found. Please log in.");
                throw new Error("No authentication token found");
            }

            const response = await axios.get(
                "https://api.uniums.com/api/faculty/faculty-leave-history",
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            setAllLeaves(response.data.data);
            setFilteredLeaves(response.data.data);
        } catch (err) {
            console.error("Error fetching all leave requests:", err);
            setError("Failed to fetch leave requests. Please try again later.");
        }finally {
            setLoading(false);
        }
    };
    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        if (query) {
            const filtered = allLeaves.filter(
                (request) =>
                    request.employeeCode.toLowerCase().includes(query.toLowerCase()) ||
                    request.name.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredLeaves(filtered);
        } else {
            setFilteredLeaves(allLeaves);
        }
    };

    const indexOfLastLeave = currentPage * leavesPerPage;
    const indexOfFirstLeave = indexOfLastLeave - leavesPerPage;
    const currentLeaves = filteredLeaves.slice(indexOfFirstLeave, indexOfLastLeave);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const formatDate = (date) => {
        const newDate = new Date(date);
        return newDate.toLocaleDateString("en-GB");
    };
    useEffect(() => {
        fetchAllLeaves();
    }, []);
    if (loading) {
        return <Loader />; 
    }

    return (
        <div className="leave-management">
            <h1>All Leave Requests</h1>
            {/* {error && <p className="error-message">{error}</p>} */}
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by Employee Code or Name"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="search-box"
                />
            </div>
            <div className="admin-table-container">
                <div className="faculty-table">
                    <table>
                        <thead>
                            <tr>
                                <th>SL No</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th>User Type</th>
                                <th>Region</th>
                                <th>Leave Type</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>Total Days</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentLeaves.length > 0 ? (
                                currentLeaves.map((request, index) => (
                                    <tr key={request._id}>
                                        <td>{index + 1}</td>
                                        <td>{request.name || "N/A"}</td>
                                        <td>{request.status || "Pending"}</td>
                                        <td>{request.employeeCode || "N/A"}</td>
                                        <td>{request.reason || "N/A"}</td>
                                        <td>{request.leaveType || "N/A"}</td>
                                        <td>{formatDate(request.startDate) || "N/A"}</td>
                                        <td>{formatDate(request.endDate) || "N/A"}</td>
                                        <td>
                                            {calculateTotalDays(request.startDate, request.endDate)}
                                        </td>
                                        <td>{request.adminComment || "N/A"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="error">No approved or rejected leave requests.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="pagination">
                <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                    Prev
                </button>
                <span>Page {currentPage}</span>
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === Math.ceil(filteredLeaves.length / leavesPerPage)}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default FacultyLeaveHistory;
